<template>
  <!--
    Info panel for the cashbook capture screen: where the bank account stands, what this batch
    will move, and the resulting balance. Fed by query set group "Cashbook Balance Queries"
    (meta.query CashbookBalance), parameterised on CashbookHeaderId from the form record context.
  -->
  <div v-if="balance" class="rounded border border-gray-200 p-3 text-sm">
    <div class="font-semibold mb-2">
      {{ balance.bank_gl_description }}
      <span v-if="balance.bank_gl_code" class="font-normal text-gray-500">
        ({{ balance.bank_gl_code }})
      </span>
      <span v-if="balance.batch_status" class="ml-2 font-normal text-gray-400">
        &middot; {{ balance.batch_status }}
      </span>
    </div>

    <div class="grid grid-cols-3 gap-3">
      <div>
        <div class="text-gray-500">Bank balance</div>
        <div class="font-semibold">{{ money(balance.bank_balance) }}</div>
      </div>
      <div>
        <div class="text-gray-500">
          This batch
          <span v-if="balance.line_count != null" class="text-gray-400">
            ({{ balance.line_count }})
          </span>
        </div>
        <div class="font-semibold">{{ money(balance.batch_total) }}</div>
      </div>
      <div>
        <div class="text-gray-500">After posting</div>
        <div class="font-semibold">
          {{ money(balance.balance_after_posting) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const value = defineModel<any>("value");
const form = defineModel<any>("form", {
  default: () => ({}),
});
const props = defineProps<{
  data: any;
}>();

// TemplateQuerySet returns results keyed by the query set description.
const balance = computed(() => {
  const rows = props.data?.["Cashbook Balance"];
  return Array.isArray(rows) && rows.length ? rows[0] : null;
});

function money(v: any) {
  if (v === null || v === undefined) return "-";
  return new Intl.NumberFormat("en-ZA", {
    style: "currency",
    currency: "ZAR",
    minimumFractionDigits: 2,
  }).format(Number(v));
}
</script>

<style scoped></style>
